<img class="wl-profile-indicator-icon" [ngClass]="moreClass" [src]="imageSrcPath" alt="" [ngStyle]="moreStyle" />
